import React, { useState } from "react";
import { BellOutlined, MailOutlined } from "@ant-design/icons";
import { Badge, Dropdown, List, Typography, Avatar, Empty } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatMessageTime } from "../utils/formatMessageTime";

const emailTemplates = [
  "You’ve received an email from {{name}}.",
  "New email from {{name}}.",
  "{{name}} sent you an email.",
  "Incoming message from {{name}}.",
  "Message received from {{name}}.",
];

const replyTemplates = [
  "{{name}} replied to your email.",
  "You’ve got a reply from {{name}}.",
  "{{name}} has responded to your message.",
  "Reply received from {{name}}.",
  "{{name}} just replied to your email.",
];

const getRandomEmailMessage = (name) => {
  const index = Math.floor(Math.random() * emailTemplates.length);
  return emailTemplates[index].replace("{{name}}", name);
};

const getRandomReplyMessage = (name) => {
  const index = Math.floor(Math.random() * replyTemplates.length);
  return replyTemplates[index].replace("{{name}}", name);
};
const NotificationDropdown = () => {
  const [viewAll, setViewAll] = useState(false);
  const unreadNotifications = useSelector(
    (state) => state.LeadDetailsReducer.unreadNotifications
  );

  return (
    <Dropdown
      dropdownRender={() => (
        <div className="notification-dropdown">
          <div className="notification-header">Notifications</div>
          {unreadNotifications?.length ? (
            <>
              <List
                itemLayout="horizontal"
                dataSource={
                  viewAll
                    ? unreadNotifications
                    : unreadNotifications.slice(0, 4)
                }
                renderItem={(item) => (
                  <Link to={`/lead-details/${item?.clientLeadId}?type=email`}>
                    <List.Item className="notification-item">
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            className="notification-avatar"
                            icon={<MailOutlined />}
                          />
                        }
                        title={
                          <Typography.Text strong>
                            {item?.subject?.includes("Re")
                              ? getRandomReplyMessage(item.leadName)
                              : getRandomEmailMessage(item.leadName)}
                          </Typography.Text>
                        }
                        description={
                          <div className="notification-time">
                            {formatMessageTime(item.createdDate)}
                          </div>
                        }
                      />
                    </List.Item>
                  </Link>
                )}
              />
              {unreadNotifications.length > 4 && (
                <div
                  className="notification-footer"
                  onClick={() => setViewAll(!viewAll)}
                >
                  {viewAll ? "View Less" : "View All"}
                </div>
              )}
            </>
          ) : (
            <div className="notification-empty">
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No notifications"
              />
            </div>
          )}
        </div>
      )}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Badge count={unreadNotifications.length} size="small" offset={[-2, 2]}>
        <BellOutlined className="notification-icon" />
      </Badge>
    </Dropdown>
  );
};

export default NotificationDropdown;
